import type { ReactNode } from 'react'
import { useAttendeeAuth } from '../contexts/AttendeeAuthContext'
import ProfileOnboardingPage from '../pages/ProfileOnboardingPage'

/**
 * First-login onboarding gate. When a signed-in attendee hasn't completed the
 * required profile (photo/avatar + bio + headline), block the app behind the
 * onboarding screen. In open/demo mode (no auth) this is a no-op.
 */
export default function RequireProfile({ children }: { children: ReactNode }) {
  const { authAvailable, isAuthenticated, me } = useAttendeeAuth()

  if (authAvailable && isAuthenticated && me?.needsOnboarding) {
    return <ProfileOnboardingPage />
  }
  return <>{children}</>
}
